export default __webpack_public_path__ + "static/media/wisdot.6dbbffad.png";